import Block from './Block'
import sharedData from '../shared-data'

export default class MapBlock extends Block {
    
    constructor(elementRoot) {
        super(elementRoot)
        
        this.mapRoot = this.root.find('.acf-map')
        
        this.markers = this.mapRoot.find('.acf-map__marker').toArray().map(m => {
            let marker = {
                latLng: {
                    lat: Number.parseFloat(m.dataset.lat),
                    lng: Number.parseFloat(m.dataset.lng),
                },
                html: m.innerHTML,
            }
            $(m).remove()
            return marker
        })
        this.map = null
        
        sharedData.googleMap.loadAssetsAsync(() => this.createMap())
    }
    
    createMap() {
        this.map = new google.maps.Map(this.mapRoot.get(0), {
            zoom: sharedData.googleMap.defaultZoomLevel,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            draggable: false,
            styles: sharedData.googleMap.style,
        })
        
        let bounds = new google.maps.LatLngBounds()
        this.markers.map(m => bounds.extend(m.latLng))
        this.markers.length > 1 ? this.map.fitBounds(bounds) : this.map.setCenter(bounds.getCenter())
        
        google.maps.event.addListener(this.map, 'click', event => {
            this.map.setOptions({
                scrollwheel: true,
                draggable: true,
            })
        })
        
        this.markers.map(m => {
            let marker = new google.maps.Marker({
                position: m.latLng,
                map: this.map,
            })
            if (m.html) {
                let infowindow = new google.maps.InfoWindow({ content: marker.html })
                google.maps.event.addListener(marker, 'click', () => infowindow.open(this.map, marker))
            }
        })
    }
}
